// extracted by mini-css-extract-plugin
export default {"item":"news_item__EOF3W","img":"news_img__sbwC3"};